import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.9596 12L14 22.0235L12.0202 24L1.9798 13.9765L0 12L1.9798 10.0235L12.0202 0L14 1.97647L3.9596 12Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["width", "height"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", { d: "M13.468 12.37C12.758 11.226 11.195 10 8 10s-4.757 1.225-5.468 2.37A6.987 6.987 0 0 0 8 15a6.987 6.987 0 0 0 5.468-2.63z" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["width", "height"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", { d: "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" }, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["width", "height"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
}, null, -1)
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = ["width", "height"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
}, null, -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = ["width", "height"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["width", "height"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  d: "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z",
  "p-id": "8853"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", {
  d: "M355.9 534.9L354 653.8c-0.1 8.9 7.1 16.2 16 16.2h0.4l118-2.9c2-0.1 4-0.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1 0.8-5.7 2.3l-415.8 415c-1.4 1.5-2.3 3.5-2.3 5.6z m63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1 0.7-46.4z",
  "p-id": "8854"
}, null, -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = ["width", "height"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("path", {
  d: "M257.7 752c2 0 4-0.2 6-0.5L431.9 722c2-0.4 3.9-1.3 5.3-2.8l423.9-423.9c3.9-3.9 3.9-10.2 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2c-1.9 11.1 1.5 21.9 9.4 29.8 6.6 6.4 14.9 9.9 23.8 9.9z m67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z",
  "p-id": "8055"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["width", "height"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
}, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = ["width", "height"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("path", {
  d: "M881.7 187.4l-45.1-45.1c-3.1-3.1-8.2-3.1-11.3 0L667.8 299.9l-54.7-54.7c-4.7-4.7-12.7-1.9-13.5 4.7L576.1 439c-0.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-0.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-0.1-11.2zM439 576.1l-189.2 23.5c-6.6 0.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5c-3.1 3.1-3.1 8.2 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7c4.7 4.7 12.7 1.9 13.5-4.7L447.9 585c0.7-5.2-3.7-9.6-8.9-8.9z",
  "p-id": "8995"
}, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["width", "height"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("path", {
  d: "M855 160.1l-189.2 23.5c-6.6 0.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5c-3.1 3.1-3.1 8.2 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7c4.7 4.7 12.7 1.9 13.5-4.7L863.9 169c0.7-5.2-3.7-9.6-8.9-8.9zM416.6 562.3c-3.1-3.1-8.2-3.1-11.3 0L251.8 715.9l-54.7-54.7c-4.7-4.7-12.7-1.9-13.5 4.7L160.1 855c-0.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-0.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z",
  "p-id": "9136"
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["width", "height"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("path", {
  d: "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-0.3 13 6.3 12.9l167-0.8c5.2 0 9-4.9 7.7-9.9L369.8 727c-1.6-6.5-10-8.3-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26-29.4-29.4-52.5-63.6-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5c-16.1 38.1-39.2 72.3-68.6 101.7-7.5 7.5-15.3 14.5-23.4 21.2-3.4 2.8-3.9 7.7-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z",
  "p-id": "9277"
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["width", "height"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.646 13.854a.5.5 0 0 0 .708 0L8 10.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-11.708a.5.5 0 0 1 .708 0L8 5.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708z"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["width", "height"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
}, null, -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["width", "height"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
}, null, -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = ["width", "height"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("path", { d: "M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("path", { d: "M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("path", { d: "M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.646 14.354l-12-12 .708-.708 12 12-.708.708z"
}, null, -1)
const _hoisted_64 = [
  _hoisted_60,
  _hoisted_61,
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = ["width", "height"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
}, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = ["width", "height"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
}, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
}, null, -1)
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = ["width", "height"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"
}, null, -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = ["width", "height"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
}, null, -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = ["width", "height"]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.523-3.356c.329-.314.158-.888-.283-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767l-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288l1.847-3.658 1.846 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.564.564 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"
}, null, -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = ["width", "height"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("path", { d: "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" }, null, -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = ["width", "height"]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
}, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.331 9.5a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5z"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("path", { d: "M7 6.5c0 .828-.448 0-1 0s-1 .828-1 0S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 0-1 0s-1 .828-1 0S9.448 5 10 5s1 .672 1 1.5z" }, null, -1)
const _hoisted_88 = [
  _hoisted_85,
  _hoisted_86,
  _hoisted_87
]
const _hoisted_89 = ["width", "height"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
}, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("path", { d: "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" }, null, -1)
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]
const _hoisted_93 = ["width", "height"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
}, null, -1)
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = ["width", "height"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1 15.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM11.5 2H11V1h.5A1.5 1.5 0 0 1 13 2.5V15h-1V2.5a.5.5 0 0 0-.5-.5z"
}, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.828.122A.5.5 0 0 1 11 .5V15h-1V1.077l-6 .857V15H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117z"
}, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("path", { d: "M8 9c0 .552.224 1 .5 1s.5-.448.5-1-.224-1-.5-1-.5.448-.5 1z" }, null, -1)
const _hoisted_101 = [
  _hoisted_98,
  _hoisted_99,
  _hoisted_100
]
const _hoisted_102 = ["width", "height"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
}, null, -1)
const _hoisted_105 = [
  _hoisted_103,
  _hoisted_104
]
const _hoisted_106 = ["width", "height"]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("path", { d: "M5.94203 8L0 13.9636L2.02899 16L10 8L2.02899 0L0 2.03636L5.94203 8Z" }, null, -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = ["width", "height"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("path", { d: "M4.05797 8L10 13.9636L7.97101 16L0 8L7.97101 0L10 2.03636L4.05797 8Z" }, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = ["width", "height"]
const _hoisted_113 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h8A1.5 1.5 0 0 1 11 1.5v2A1.5 1.5 0 0 1 9.5 5h-8A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-8zM14 7H2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM2 6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H2z"
}, null, -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 11H1v-1h14v1zM2 12.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
}, null, -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("path", { d: "M7.823 2.823l-.396-.396A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0z" }, null, -1)
const _hoisted_116 = [
  _hoisted_113,
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = ["width", "height"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("path", {
  d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
  "p-id": "8070"
}, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("path", {
  d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7c0-19.7 12.4-37.7 30.9-44.8 59-22.7 97.1-74.7 97.1-132.5 0.1-39.3-17.1-76-48.3-103.3z",
  "p-id": "8071"
}, null, -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("path", {
  d: "M512 732m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
  "p-id": "8072"
}, null, -1)
const _hoisted_121 = [
  _hoisted_118,
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = ["width", "height"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("path", { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" }, null, -1)
const _hoisted_124 = [
  _hoisted_123
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.name === 'back')
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        width: _ctx.parsedWidth,
        height: _ctx.parsedHeight,
        viewBox: "0 0 14 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_3, 8, _hoisted_1))
    : (_ctx.name === 'cloud')
      ? (_openBlock(), _createElementBlock("svg", {
          key: 1,
          width: _ctx.parsedWidth,
          height: _ctx.parsedHeight,
          viewBox: "0 2.5 16 10",
          fill: "currentColor",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_7, 8, _hoisted_4))
      : (_ctx.name === 'my')
        ? (_openBlock(), _createElementBlock("svg", {
            key: 2,
            width: _ctx.parsedWidth,
            height: _ctx.parsedHeight,
            viewBox: "0 0 16 16",
            class: "bi bi-person-circle",
            fill: "currentColor",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_12, 8, _hoisted_8))
        : (_ctx.name === 'notification')
          ? (_openBlock(), _createElementBlock("svg", {
              key: 3,
              width: _ctx.parsedWidth,
              height: _ctx.parsedHeight,
              viewBox: "0 0 16 16",
              fill: "currentColor",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_16, 8, _hoisted_13))
          : (_ctx.name === 'rating')
            ? (_openBlock(), _createElementBlock("svg", {
                key: 4,
                width: _ctx.parsedWidth,
                height: _ctx.parsedHeight,
                viewBox: "0 0 16 16",
                fill: "currentColor",
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_21, 8, _hoisted_17))
            : (_ctx.name === 'search')
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 5,
                  width: _ctx.parsedWidth,
                  height: _ctx.parsedHeight,
                  viewBox: "0 0 16 16",
                  fill: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_25, 8, _hoisted_22))
              : (_ctx.name === 'timetable')
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 6,
                    width: _ctx.parsedWidth,
                    height: _ctx.parsedHeight,
                    viewBox: "0 0 16 16",
                    fill: "currentColor",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _hoisted_28, 8, _hoisted_26))
                : (_ctx.name === 'edit-square')
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 7,
                      width: _ctx.parsedWidth,
                      height: _ctx.parsedHeight,
                      viewBox: "0 0 1024 1024",
                      fill: "currentColor",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_32, 8, _hoisted_29))
                  : (_ctx.name === 'edit')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 8,
                        width: _ctx.parsedWidth,
                        height: _ctx.parsedHeight,
                        viewBox: "0 0 1024 1024",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_35, 8, _hoisted_33))
                    : (_ctx.name === 'delete')
                      ? (_openBlock(), _createElementBlock("svg", {
                          key: 9,
                          width: _ctx.parsedWidth,
                          height: _ctx.parsedHeight,
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, _hoisted_39, 8, _hoisted_36))
                      : (_ctx.name === 'shrink')
                        ? (_openBlock(), _createElementBlock("svg", {
                            key: 10,
                            width: _ctx.parsedWidth,
                            height: _ctx.parsedHeight,
                            viewBox: "0 0 1024 1024",
                            fill: "currentColor",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, _hoisted_42, 8, _hoisted_40))
                        : (_ctx.name === 'arrawsalt')
                          ? (_openBlock(), _createElementBlock("svg", {
                              key: 11,
                              width: _ctx.parsedWidth,
                              height: _ctx.parsedHeight,
                              viewBox: "0 0 1024 1024",
                              fill: "currentColor",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_45, 8, _hoisted_43))
                          : (_ctx.name === 'undo')
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 12,
                                width: _ctx.parsedWidth,
                                height: _ctx.parsedHeight,
                                viewBox: "0 0 1024 1024",
                                fill: "currentColor",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, _hoisted_48, 8, _hoisted_46))
                            : (_ctx.name === 'contract')
                              ? (_openBlock(), _createElementBlock("svg", {
                                  key: 13,
                                  width: _ctx.parsedWidth,
                                  height: _ctx.parsedHeight,
                                  viewBox: "0 0 16 16",
                                  fill: "currentColor",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, _hoisted_51, 8, _hoisted_49))
                              : (_ctx.name === 'expand')
                                ? (_openBlock(), _createElementBlock("svg", {
                                    key: 14,
                                    width: _ctx.parsedWidth,
                                    height: _ctx.parsedHeight,
                                    viewBox: "0 0 16 16",
                                    fill: "currentColor",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, _hoisted_54, 8, _hoisted_52))
                                : (_ctx.name === 'eye')
                                  ? (_openBlock(), _createElementBlock("svg", {
                                      key: 15,
                                      width: _ctx.parsedWidth,
                                      height: _ctx.parsedHeight,
                                      viewBox: "0 0 16 16",
                                      fill: "currentColor",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, _hoisted_58, 8, _hoisted_55))
                                  : (_ctx.name === 'eye-slash')
                                    ? (_openBlock(), _createElementBlock("svg", {
                                        key: 16,
                                        width: _ctx.parsedWidth,
                                        height: _ctx.parsedHeight,
                                        viewBox: "0 0 16 16",
                                        fill: "currentColor",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, _hoisted_64, 8, _hoisted_59))
                                    : (_ctx.name === 'plus')
                                      ? (_openBlock(), _createElementBlock("svg", {
                                          key: 17,
                                          width: _ctx.parsedWidth,
                                          height: _ctx.parsedHeight,
                                          viewBox: "4 4 8 8",
                                          fill: "currentColor",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }, _hoisted_67, 8, _hoisted_65))
                                      : (_ctx.name === 'plus-circle')
                                        ? (_openBlock(), _createElementBlock("svg", {
                                            key: 18,
                                            width: _ctx.parsedWidth,
                                            height: _ctx.parsedHeight,
                                            viewBox: "0 0 16 16",
                                            fill: "currentColor",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }, _hoisted_71, 8, _hoisted_68))
                                        : (_ctx.name === 'heart')
                                          ? (_openBlock(), _createElementBlock("svg", {
                                              key: 19,
                                              width: _ctx.parsedWidth,
                                              height: _ctx.parsedHeight,
                                              viewBox: "0 0 16 16",
                                              fill: "currentColor",
                                              xmlns: "http://www.w3.org/2000/svg"
                                            }, _hoisted_74, 8, _hoisted_72))
                                          : (_ctx.name === 'heart-fill')
                                            ? (_openBlock(), _createElementBlock("svg", {
                                                key: 20,
                                                width: _ctx.parsedWidth,
                                                height: _ctx.parsedHeight,
                                                viewBox: "0 0 16 16",
                                                fill: "currentColor",
                                                xmlns: "http://www.w3.org/2000/svg"
                                              }, _hoisted_77, 8, _hoisted_75))
                                            : (_ctx.name === 'star')
                                              ? (_openBlock(), _createElementBlock("svg", {
                                                  key: 21,
                                                  width: _ctx.parsedWidth,
                                                  height: _ctx.parsedHeight,
                                                  viewBox: "0 0 16 16",
                                                  fill: "currentColor",
                                                  xmlns: "http://www.w3.org/2000/svg"
                                                }, _hoisted_80, 8, _hoisted_78))
                                              : (_ctx.name === 'star-fill')
                                                ? (_openBlock(), _createElementBlock("svg", {
                                                    key: 22,
                                                    width: _ctx.parsedWidth,
                                                    height: _ctx.parsedHeight,
                                                    viewBox: "0 0 16 16",
                                                    fill: "currentColor",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  }, _hoisted_83, 8, _hoisted_81))
                                                : (_ctx.name === 'reaction')
                                                  ? (_openBlock(), _createElementBlock("svg", {
                                                      key: 23,
                                                      width: _ctx.parsedWidth,
                                                      height: _ctx.parsedHeight,
                                                      viewBox: "0 0 16 16",
                                                      fill: "currentColor",
                                                      xmlns: "http://www.w3.org/2000/svg"
                                                    }, _hoisted_88, 8, _hoisted_84))
                                                  : (_ctx.name === 'chat')
                                                    ? (_openBlock(), _createElementBlock("svg", {
                                                        key: 24,
                                                        width: _ctx.parsedWidth,
                                                        height: _ctx.parsedHeight,
                                                        viewBox: "0 0 16 16",
                                                        fill: "currentColor",
                                                        xmlns: "http://www.w3.org/2000/svg"
                                                      }, _hoisted_92, 8, _hoisted_89))
                                                    : (_ctx.name === 'trash')
                                                      ? (_openBlock(), _createElementBlock("svg", {
                                                          key: 25,
                                                          width: _ctx.parsedWidth,
                                                          height: _ctx.parsedHeight,
                                                          viewBox: "0 0 16 16",
                                                          fill: "currentColor",
                                                          xmlns: "http://www.w3.org/2000/svg"
                                                        }, _hoisted_96, 8, _hoisted_93))
                                                      : (_ctx.name === 'door-open')
                                                        ? (_openBlock(), _createElementBlock("svg", {
                                                            key: 26,
                                                            width: _ctx.parsedWidth,
                                                            height: _ctx.parsedHeight,
                                                            viewBox: "0 0 16 16",
                                                            fill: "currentColor",
                                                            xmlns: "http://www.w3.org/2000/svg"
                                                          }, _hoisted_101, 8, _hoisted_97))
                                                        : (_ctx.name === 'pencil-square')
                                                          ? (_openBlock(), _createElementBlock("svg", {
                                                              key: 27,
                                                              width: _ctx.parsedWidth,
                                                              height: _ctx.parsedHeight,
                                                              viewBox: "0 0 16 16",
                                                              fill: "currentColor",
                                                              xmlns: "http://www.w3.org/2000/svg"
                                                            }, _hoisted_105, 8, _hoisted_102))
                                                          : (_ctx.name === 'right')
                                                            ? (_openBlock(), _createElementBlock("svg", {
                                                                key: 28,
                                                                width: _ctx.parsedWidth,
                                                                height: _ctx.parsedHeight,
                                                                viewBox: "0 0 10 16",
                                                                fill: "currentColor",
                                                                xmlns: "http://www.w3.org/2000/svg"
                                                              }, _hoisted_108, 8, _hoisted_106))
                                                            : (_ctx.name === 'left')
                                                              ? (_openBlock(), _createElementBlock("svg", {
                                                                  key: 29,
                                                                  width: _ctx.parsedWidth,
                                                                  height: _ctx.parsedHeight,
                                                                  viewBox: "0 0 10 16",
                                                                  fill: "currentColor",
                                                                  xmlns: "http://www.w3.org/2000/svg"
                                                                }, _hoisted_111, 8, _hoisted_109))
                                                              : (_ctx.name === 'menu-button')
                                                                ? (_openBlock(), _createElementBlock("svg", {
                                                                    key: 30,
                                                                    width: _ctx.parsedWidth,
                                                                    height: _ctx.parsedHeight,
                                                                    viewBox: "0 0 16 16",
                                                                    fill: "currentColor",
                                                                    xmlns: "http://www.w3.org/2000/svg"
                                                                  }, _hoisted_116, 8, _hoisted_112))
                                                                : (_ctx.name === 'question-circle')
                                                                  ? (_openBlock(), _createElementBlock("svg", {
                                                                      key: 31,
                                                                      width: _ctx.parsedWidth,
                                                                      height: _ctx.parsedHeight,
                                                                      viewBox: "0 0 1024 1024",
                                                                      fill: "currentColor",
                                                                      xmlns: "http://www.w3.org/2000/svg"
                                                                    }, _hoisted_121, 8, _hoisted_117))
                                                                  : (_ctx.name === 'close')
                                                                    ? (_openBlock(), _createElementBlock("svg", {
                                                                        key: 32,
                                                                        width: _ctx.parsedWidth,
                                                                        height: _ctx.parsedHeight,
                                                                        fill: "currentColor",
                                                                        viewBox: "64 64 896 896"
                                                                      }, _hoisted_124, 8, _hoisted_122))
                                                                    : _createCommentVNode("", true)
}